import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Slide } from 'pure-react-carousel';
import CarouselSlider from 'components/atoms/TemplateCarouselSlider';
const { kakao } = window;
/**
 * kakao map
 */
const Map = ({ boxStyle, item, viewType, mapkey }) => {
  const { items } = item;
  const mapIdx = mapkey;

  const slideBoxSet = boxStyle;
  const slideBoxSetStyle = {
    width: `${slideBoxSet.width}px`,
    height: slideBoxSet.height,
    marginRight: `${slideBoxSet.margin}px`,
  };
  const slideLength = items.length;

  useEffect(async () => {
    await kakao.maps.load(() => {
      for (let i = 0; i < items.length; i++) {
        const container = document.getElementById(`map_${mapIdx}_${i}`);
        const options = {
          center: new window.kakao.maps.LatLng(items[i]?.y?.value, items[i]?.x?.value), // lat, lon
          level: 3,
        };
        const map = new window.kakao.maps.Map(container, options);
        const marker = new window.kakao.maps.Marker({
          // 지도 중심좌표에 마커를 생성합니다
          // title : title,
          position: map.getCenter(),
        });
        // // 지도에 마커를 표시합니다
        marker.setMap(map);
      }
    });
  }, []);
  const constentSet = () => {
    return (
      <>
        {items.map((tempItem, idx) => {
          return (
            <Slide key={`slide_${idx}`} className="_machine_location" style={slideBoxSetStyle}>
              <div className="_map_container" style={{ width: '100%' }}>
                <div className="_kakaomap_div" id={`map_${mapIdx}_${idx}_div`}>
                  <div id={`map_${mapIdx}_${idx}`} style={{ width: '100%', height: '300px', borderRadius: '20px' }} />
                </div>
                <div className="_map_title" id={`map_title_${mapIdx}_div`}>
                  <div id={`map_title_${mapIdx}`} style={{ width: '100%' }}>
                    {ReactHtmlParser(tempItem?.text?.value || '')}
                  </div>
                </div>
              </div>
            </Slide>
          );
        })}
      </>
    );
  };
  return (
    <>
      <div className="_carousel_button_div">
        <CarouselSlider slideBoxSet={slideBoxSet} contentCount={slideLength} contentSet={constentSet} />
      </div>
    </>
  );
};

Map.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  mapkey: PropTypes.string,
};
Map.defaultProps = {
  boxStyle: { width: 150, margin: 10, height: '220px' },
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  mapkey: '',
};

export default Map;
